import { InputText } from "primereact/inputtext";
import Input from "../../../../../components/input/Input";
import Switch from "../../../../../components/input/Switch";
import { useWebsite } from "../Context/WebSiteContext";
import { useCallback, useEffect } from "react";
import { ColorPicker } from "primereact/colorpicker";
import { Controller } from "react-hook-form";

const FormSite = ({ control, setValue, config, formState }) => {
  const { formData, updateFormData } = useWebsite();

  const safeFormData = {
    ...formData,
    formulario: formData.formulario || {},
  };

  const formTitle =
    config?.formulario?.tittle ?? safeFormData.formulario?.tittle ?? "";

  const getSwitchDefault = (field) =>
    config?.formulario?.[field] !== undefined
      ? config.formulario[field]
      : safeFormData.formulario?.[field] !== undefined
      ? safeFormData.formulario[field]
      : true;

  useEffect(() => {
    if (config?.formulario) {
      setValue("formulario.tittle", config.formulario.tittle ?? "");
      setValue("formulario.email", config.formulario.email ?? true);
      setValue("formulario.phone", config.formulario.phone ?? true);
      setValue("formulario.cep", config.formulario.cep ?? true);
      setValue("formulario.name", config.formulario.name ?? true);
    }
  }, [config, setValue]);

  const errors = formState?.errors || {};
  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };
  const handleSwitchChange = (field, value) => {
    setValue(`formulario.${field}`, value);
    updateFormData("formulario", field, value);
  };

  const handleColorChange = useCallback(
    (field, value) => {
      updateFormData("navbar", field, value);
      setValue(`navbar.${field}`, value, { shouldDirty: true });
      console.log(`Cor do ${field} alterada para:`, value);
    },
    [updateFormData, setValue]
  );
  
  return (
    <div className="row">
      <div className="col-md-12">
        <Input
          type="text"
          control={control}
          getFormErrorMessage={getFormErrorMessage}
          label="Titulo do Formulário"
          name="formulario.tittle"
          className="form-control"
          defaultValue={formTitle}
        />
        <div className="row mt-3">
          <div className="col-md-6 d-flex align-items-center gap-2">
            <Switch
              name="formulario.email"
              control={control}
              getFormErrorMessage={getFormErrorMessage}
              defaultValue={getSwitchDefault("email")}
              checked={getSwitchDefault("email")}
              onChange={(value) => handleSwitchChange("email", value)}
            />
            <h5 className="mb-0">Habilitar Email</h5>
          </div>

          <div className="col-md-6 d-flex align-items-center gap-2">
            <Switch
              name="formulario.phone"
              control={control}
              getFormErrorMessage={getFormErrorMessage}
              defaultValue={getSwitchDefault("phone")}
              checked={getSwitchDefault("phone")}
              onChange={(value) => handleSwitchChange("phone", value)}
            />
            <h5 className="mb-0">Habilitar Telefone</h5>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6 d-flex align-items-center gap-2">
            <Switch
              name="formulario.cep"
              control={control}
              getFormErrorMessage={getFormErrorMessage}
              defaultValue={getSwitchDefault("cep")}
              checked={getSwitchDefault("cep")}
              onChange={(value) => handleSwitchChange("cep", value)}
            />
            <h5 className="mb-0">Habilitar CEP</h5>
          </div>

          <div className="col-md-6 d-flex align-items-center gap-2">
            <Switch
              name="formulario.name"
              control={control}
              defaultValue={getSwitchDefault("name")}
              checked={getSwitchDefault("name")}
              getFormErrorMessage={getFormErrorMessage}
              onChange={(value) => handleSwitchChange("name", value)}
            />
            <h5 className="mb-0">Habilitar Nome</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormSite;
